import i18n from '@/i18n';
import { HeaderLink } from './header.interface';

export interface HeaderState {
   breadcrumbs: Array<HeaderLink>;
   tabs: Array<HeaderLink>;
}

const state: HeaderState = {
   breadcrumbs: [{ to: '/', content: i18n.global.t('app-name') }],
   tabs: [],
};

const getters = {
   breadcrumbs(state: HeaderState) {
      return state.breadcrumbs;
   },
   tabs(state: HeaderState) {
      return state.tabs;
   },
};

const mutations = {
   SET_BREADCRUMBS(state: HeaderState, breadcrumbs: Array<HeaderLink>) {
      state.breadcrumbs = [{ to: '/', content: i18n.global.t('app-name') }, ...breadcrumbs];
   },
   SET_TABS(state: HeaderState, tabs: Array<HeaderLink>) {
      state.tabs = tabs;
   },
};

const actions = {};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
